import styled from 'styled-components';

import { Row } from '../../styles/align';
import { BtnGroup, Button } from '../../styles/forms';
// Styles
import { colors, fontSize } from '../../styles/variables';
import { Container } from '../style';

/**
 * Modal de aviso de inatividade (IdleWarning)
 */
export const StyleIdleWarning = styled(Container)`
  position: relative;
  background-color: ${colors.grey.light};
  padding: 1rem;
  text-align: center;

  .infoText {
    color: ${colors.error} !important;
  }

  ${Row} {
    display: block;
    color: ${colors.grey.darkPrimary};
    padding: 0.5rem 0.5rem;

    h2 {
      color: ${colors.secondary};
      text-align: center;
      margin: 0 0 .25rem 0;
    }

    p {
      color: ${colors.black.primary};
      padding: 1rem 0 .75rem 0;
      line-height: 1.5;
      text-align: center;
      font-size: ${fontSize.lg};

      strong {
        display: inline-block;
        font-weight: 700;
        color: ${colors.black.primary};
        transform: translateZ(0); /* melhor render no countdown */
      }
    }

    ${BtnGroup} {
      width: 100%;
      justify-content: center;
      gap: .75rem;
      margin-top: .25rem;

      ${Button} {
        text-decoration: none;
        padding: .75rem 1.25rem;
        border-radius: 10px;
        font-weight: 600;
        letter-spacing: .2px;
        transition: background-color .2s ease, box-shadow .2s ease, transform .15s ease;
        will-change: transform, box-shadow;

        /* Botão laranja principal */
        background-color: ${colors.secondary};
        color: ${colors.default};
        box-shadow: 0 4px 14px rgba(0,0,0,.08);

        &:hover {
          transform: translateY(-1px);
          filter: brightness(0.95);
          box-shadow: 0 6px 18px rgba(0,0,0,.12);
        }

        &:active {
          transform: translateY(0);
          filter: brightness(0.9);
          box-shadow: 0 3px 10px rgba(0,0,0,.12);
        }

        &:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(255,140,0,.35); /* anel de foco laranja */
        }
      }
    }

    /* Fallback caso use um <button class="btn"> no conteúdo */
    .actions {
      display: flex;
      justify-content: center;
      margin-top: .25rem;

      .btn {
        cursor: pointer;
        border: 0;
        text-decoration: none;
        padding: .75rem 1.25rem;
        border-radius: 10px;
        font-weight: 600;
        letter-spacing: .2px;
        transition: background-color .2s ease, box-shadow .2s ease, transform .15s ease;
        background-color: ${colors.secondary};
        color: ${colors.default};
        box-shadow: 0 4px 14px rgba(0,0,0,.08);

        &:hover {
          transform: translateY(-1px);
          filter: brightness(0.95);
          box-shadow: 0 6px 18px rgba(0,0,0,.12);
        }

        &:active {
          transform: translateY(0);
          filter: brightness(0.9);
          box-shadow: 0 3px 10px rgba(0,0,0,.12);
        }

        &:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(255,140,0,.35);
        }
      }
    }
  }
`;
